// extracted by mini-css-extract-plugin
export var readonly = "_if-1";
export var star = "_if-0";